import React, { useEffect } from "react";
import { useBarcode } from "next-barcode";
import incommIcon from "assets/barcode-incomm-icon.png";
import { useTranslation } from "react-i18next";
import { BALANCE_NAMESPACE, BARCODE_VIEW } from "constants/i18n-namespaces";
import { useBiller, useCurrencyFormatter, useLabels } from "hooks";
import _ from "lodash";
import { getDomain, getLabel, mapUiLanguageToSessionLanguage } from "utilities/helper";
import i18n from "i18n/I18nApp";


export interface IBarcodeViewProps {
  barcodeText: string;
  billerName: string;
  billerLogo: string;
  accountNumber: string;
  serviceFee: number;
  payableTypeName?: string;
  payableAmount?: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const BarcodeView = (props: IBarcodeViewProps) => {
  const { barcodeText, billerLogo, accountNumber, serviceFee, payableTypeName, payableAmount } = props;
  const { t } = useTranslation([BARCODE_VIEW, BALANCE_NAMESPACE]);
  const currencyFormatter = useCurrencyFormatter();
const { loadBiller, getBiller } = useBiller();
const biller = getBiller();
const { loadLabels, getLabels } = useLabels();
  const labelSource = getLabels();
  // Display Servicefee text if enabled and > 0
  let serviceFeeDisplay = "";
  if (serviceFee !== undefined && serviceFee > 0.0) {
    serviceFeeDisplay = t("service-fee-label", {
      serviceFee: currencyFormatter.format(serviceFee),
    });
  }

  //Set barcode properties
  const { inputRef } =
    useBarcode({
      value: barcodeText,
      options: {
        displayValue: true,
        background: "#ffffff",
        fontSize: 22,
      },
    }) || {};

    useEffect(() => {
        loadBiller();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    
      useEffect(() => {
        if (!biller || !biller.clientId || !biller.realm || !biller.instanceId)
          return;
    
        const { clientId, realm, instanceId } = biller;
        const language = mapUiLanguageToSessionLanguage(
          i18n.resolvedLanguage ?? "en"
        );
        const domain = getDomain();
    
        loadLabels(clientId, instanceId, domain, realm, language, [], "false");
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [biller]);

  return (
    <div
      className="barcode-view"
      id="barcodeview"
      title={`${t("barcode-view-title")}`}
    >
      <div className="cash-account-logo-container">
        <div className="cash-biller-logo-container">
          <img
            src={billerLogo}
            alt={`${t("biller-logo-alt", { billerName: props.billerName })}`}
            className="biller-logo-cash"
            data-cy="biller-logo"
          />
        </div>
       {( _.isEmpty(payableTypeName) && <div className="cash-account-number">
          <div className="account-display-cash" data-cy="account-number">
            <b>{t("account-number")}</b> {accountNumber}
          </div>
        </div>)}
        
        { !_.isEmpty(payableTypeName) && (<div className="cash-account-details">
          <div className="cash-account-number">
            <div className="account-display-cash" data-cy="account-number">
              <b>{getLabel(labelSource.labels, payableTypeName ?? "")}:</b> {accountNumber}
            </div>
          </div>
          <div className="cash-account-number">
            <div className="account-display-cash" data-cy="account-number">
              <b>{t("amount", {ns: BALANCE_NAMESPACE })}:</b> {currencyFormatter.format(payableAmount ?? 0.0)}
            </div>
          </div>
        </div>)}
        {/* <div style={{ width: "100%", textAlign: "right", marginTop: "0px",  }}>parking ticket</div>
        <div style={{ width: "100%", textAlign: "right", marginTop: "8px" }}>Amount</div> */}
        
      </div>

      <div className="barcode-container">
        <div className="barcode-column">
          <img src={incommIcon} alt="Incomm icon" className="incom-icon" />
          <canvas
            ref={inputRef}
            className="barcode"
            title={`${t("cash-barcode-title")}`}
            data-cy="cash-barcode"
          />
        </div>
      </div>
      <div className="content-row">
        <div className="left-text-14" data-cy="link-how-to-use-barcode">
          {t("how-to-use-barcode", { serviceFee: serviceFeeDisplay })}
        </div>
      </div>
      <div className="content-row">
        <div className="left-text-10">
          {t("barcode-disclaimer", {
            termsUrl: "vanilladirect.com/pay/terms",
            receiptUrl: "vanilladirect.com/pay/ereceipt",
            phoneNumber: "(888)-888-8888",
            interpolation: {
              escapeValue: false,
            },
          })}
        </div>
      </div>
    </div>
  );
};
